module.exports = __webpack_public_path__ + "bl.svg?51e35f0fca6eab74cbf6b4127a647801";